<template>
  <div v-if="isOpen" :class="$style.modal">
    <div :class="$style.overlay" @click="$emit('close')"></div>
    <div :class="$style.content" @click.stop>
      <div :class="$style.top">
        <div :class="$style.close" @click.stop="$emit('close')">
          <img src="/icons/common/cross-black.svg" alt="" />
        </div>
        Редактирование записи
      </div>
      <div :class="$style.body">
        <div>
          <div :class="$style.field">
            <div :class="$style.title">Начало</div>
            <div :class="$style.input">
              <input
                type="text"
                v-model="editStartTime"
                placeholder="HH:MM:SS"
              />
            </div>
          </div>
          <div :class="$style.field">
            <div :class="$style.title">Окончание</div>
            <div :class="$style.input">
              <input type="text" v-model="editEndTime" placeholder="HH:MM:SS" />
            </div>
          </div>
          <div :class="$style.field">
            <div :class="$style.title">Трудовая операция</div>
            <CommonSelectFilter
              placeholder="Выберите операцию"
              :hints="activityHints"
              :value="currentActivityName"
              @setHint="(val) => (editActivityId = val)"
            />
          </div>
          <div :class="$style.field">
            <div :class="$style.title">Длительность (мин)</div>
            <div :class="$style.input">
              <input type="text" :value="activity?.delta" disabled />
            </div>
          </div>
        </div>
        <div>
          <div :class="$style.field">
            <div :class="$style.title">Комментарий наблюдателя</div>
            <div :class="$style.commentBlock">
              <div :class="$style.input">
                <textarea v-model="observerComment" />
              </div>
              <div :class="$style.images" v-if="observerFiles?.length">
                <div
                  v-for="(file, fIndex) in observerFiles"
                  :key="file.id"
                  :class="$style.imageWrapper"
                >
                  <img
                    v-if="isImage(file.file)"
                    :src="file.file"
                    :class="$style.thumb"
                  />
                  <div v-else :class="$style.thumbPlaceholder">
                    <img
                      src="/icons/common/add-file-black.svg"
                      alt="File"
                      :class="$style.fileIcon"
                    />
                  </div>
                  <div :class="$style.deleteBtn" @click="deleteImage(fIndex)">
                    <img src="/icons/common/cross-black.svg" alt="Del" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="$style.field">
            <div :class="$style.title">Комментарий администратора</div>
            <div :class="$style.input">
              <textarea v-model="editAdminComment" />
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.footer">
        <button :class="$style.saveButton" @click="saveActivity">
          Сохранить
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Repository from "@/repository";
import CommonSelectFilter from "@/components/common/CommonSelectFilter.vue";
import { isImage } from "@/utils/file";

export default {
  name: "EditActivityModal",
  components: {
    CommonSelectFilter,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    activity: {
      type: Object,
      default: () => ({}),
    },
    supervisionId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      editStartTime: "",
      editEndTime: "",
      editActivityId: null,
      editAdminComment: "",
      observerComment: "",
      observerFiles: [],
      activitiesList: [],
    };
  },
  watch: {
    activity: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.editStartTime = newVal?.start_date?.substr(11, 8) || "--:--:--";
          this.editEndTime = newVal?.end_date?.substr(11, 8) || "--:--:--";
          this.editActivityId = newVal?.activity?.id || null;
          this.editAdminComment = newVal?.admin_comment || "";

          // Merge all comments into one
          const comments = newVal?.comments || [];
          this.observerComment = comments
            .map((c) => c.text)
            .filter((t) => t)
            .join("\n");
          this.observerFiles = comments.flatMap((c) => c.files || []);
        }
      },
      immediate: true,
    },
    isOpen: {
      handler(val) {
        if (val) {
          this.fetchActivities();
        }
      },
      immediate: true,
    },
  },
  computed: {
    activityHints() {
      return this.activitiesList.map((item) => ({
        title: item.name,
        slug: item.id,
      }));
    },
    currentActivityName() {
      const found = this.activitiesList.find(
        (item) => item.id === this.editActivityId
      );
      return found ? found.name : "";
    },
  },
  methods: {
    async fetchActivities() {
      if (!this.supervisionId) return;
      try {
        const { value } = await Repository.Layouts.get({
          supervision_id: this.supervisionId,
        });
        if (value && value.length > 0) {
          // Flatten activities from all groups
          this.activitiesList = value.flatMap((layout) =>
            layout.activity_groups
              ? layout.activity_groups.flatMap(
                  (group) => group.activities || []
                )
              : []
          );
          // Remove duplicates if any
          this.activitiesList = [
            ...new Map(
              this.activitiesList.map((item) => [item.id, item])
            ).values(),
          ];
        }
      } catch (e) {
        console.error("Failed to fetch activities", e);
      }
    },
    deleteImage(fIndex) {
      this.observerFiles.splice(fIndex, 1);
    },
    isImage,
    async saveActivity() {
      if (!this.activity?.id) {
        return;
      }

      // Формируем даты из времени
      const startDate = this.activity?.start_date || "";
      const datePart = startDate ? startDate.substr(0, 10) : "";

      const payload = {
        admin_comment: this.editAdminComment || null,
        activity_id: this.editActivityId,
        comments: [
          {
            text: this.observerComment,
            files: this.observerFiles.map((file) => file.id),
          },
        ],
      };

      // Если изменено время начала
      if (this.editStartTime && this.editStartTime !== "--:--:--") {
        payload.start_date = datePart
          ? `${datePart}T${this.editStartTime}`
          : null;
      }

      // Если изменено время окончания
      if (this.editEndTime && this.editEndTime !== "--:--:--") {
        payload.end_date = datePart ? `${datePart}T${this.editEndTime}` : null;
      }

      this.$store.commit("setLoadersCount", "+");
      const { value, error } = await Repository.Supervision.Analytics.update({
        id: this.activity.id,
        payload,
      });
      this.$store.commit("setLoadersCount", "-");

      if (value) {
        this.$emit("saved", value);
        this.$emit("close");
      } else if (error) {
        console.error("Error updating activity:", error);
      }
    },
  },
  emits: ["close", "saved"],
};
</script>

<style lang="scss" module>
@keyframes expand {
  from {
    transform: scale(0.7);
    opacity: 0;
  }
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 70;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(1.25rem);
    transition: opacity 0.3ms;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
  }
  .content {
    position: fixed;
    left: 50%;
    top: 50%;
    max-height: calc(100vh - 4rem);
    overflow: auto;
    @include scrollbarY;
    transform: translate(-50%, -50%);
    background-color: $bg-white;
    border-radius: 2rem;
    z-index: 70;
    animation: expand 0.2s ease-in-out;
    width: 65.25rem;
    .top {
      position: relative;
      padding: 1.5rem 0 0 0;
      text-align: center;
      font-size: 1.25rem;
      .close {
        position: absolute;
        right: 0;
        top: 0;
        img {
          padding: 1rem;
          cursor: pointer;
        }
      }
    }
    .body {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5rem;
      padding: 1.5rem;
      .field {
        margin: 0 0 1.5rem 0;
        &:last-child {
          margin: 0;
        }
        .title {
          font-weight: 700;
          margin: 0 0 0.75rem 0;
        }
        .input {
          input,
          select {
            outline: 0;
            border: none;
            padding: 1rem;
            width: 100%;
            background-color: rgba(248, 250, 250, 1);
            border-radius: 0.5rem;
            &::placeholder {
              color: $t-secondary;
            }
            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }
          textarea {
            outline: 0;
            border: none;
            padding: 1rem;
            width: 100%;
            background-color: rgba(248, 250, 250, 1);
            border-radius: 0.5rem;
            min-height: 9.75rem;
            max-width: 30.375rem;
            min-width: 30.375rem;
            max-height: 9.75rem;
            &::placeholder {
              color: $t-secondary;
            }
          }
        }
        .commentBlock {
          margin-bottom: 1rem;
          .images {
            display: flex;
            gap: 0.5rem;
            margin-top: 0.5rem;
            flex-wrap: wrap;
            .imageWrapper {
              position: relative;
              .thumb {
                width: 4rem;
                height: 4rem;
                object-fit: cover;
                border-radius: 0.5rem;
              }
              .thumbPlaceholder {
                width: 4rem;
                height: 4rem;
                border-radius: 0.5rem;
                background: #f0f0f0;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #ddd;
                .fileIcon {
                  width: 2rem;
                  height: 2rem;
                }
              }
              .deleteBtn {
                position: absolute;
                top: -0.25rem;
                right: -0.25rem;
                background: white;
                border-radius: 50%;
                width: 1rem;
                height: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
                img {
                  width: 0.5rem;
                  height: 0.5rem;
                }
              }
            }
          }
        }
        .noComments {
          color: $t-secondary;
          font-style: italic;
        }
      }
    }
    .footer {
      padding: 1.5rem;
      border-top: 1px solid rgba(248, 250, 250, 1);
      display: flex;
      justify-content: flex-end;
      .saveButton {
        padding: 0.75rem 2rem;
        background-color: $blue;
        color: white;
        border: none;
        border-radius: 0.5rem;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;
        &:hover {
          background-color: darken($blue, 10%);
        }
        &:active {
          background-color: darken($blue, 15%);
        }
      }
    }
  }
}
</style>
